import request from '@/utils/request'
const apiPath = '/sys/sysGoodsSpecValue'
const sysGoodsSpecValueApi = {
  /**
   * 新增【商品规格值】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【商品规格值】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【商品规格值】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【商品规格值】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【商品规格值】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  updateDeleted(data) {
    return request.post(apiPath + '/updateDeleted', data, { isFormData: 1 })
  },
}
export default sysGoodsSpecValueApi
